export default __webpack_public_path__ + "static/implimentation-choice-optimized-d95577762168c85087208d4c9eddaab7.jpg";